import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "152.969",
  height: "152.969"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "data-name": "Group 3655",
      opacity: ".02"
    }, [
      _createElementVNode("g", { "data-name": "Group 3654" }, [
        _createElementVNode("path", {
          fill: "#1a1818",
          d: "m45.305 129.942 52.317-50.9C109.54 67.525 115.8 57.628 115.8 47.325c0-11.109-7.071-19.189-21.21-19.189-13.13 0-21.209 6.868-29.289 17.17l-22.016-17.17C55.4 11.976 72.373 2.483 97.015 2.483c33.936 0 53.125 17.977 53.125 43.429 0 15.149-6.666 29.491-25.855 47.671l-35.349 33.329v.4h64.033v25.653H45.305Z",
          "data-name": "Path 1810"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }